import React, { useEffect, useState } from 'react';
import {
    getPostalCodes,
    getPostalCodeById,
    createPostalCode,
    updatePostalCode,
    deletePostalCode,
} from '../api/postalCodeService';

import { fetchCities } from '../api/cityService';

const PostalCodePage = () => {
    const [postalCodes, setPostalCodes] = useState([]);
    const [cities, setCities] = useState([]);

    const [form, setForm] = useState({
        code: '',
        cityId: ''
    });

    const [editId, setEditId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    useEffect(() => {
        fetchPostalCodes();
        loadCities();
    }, []);

    const fetchPostalCodes = async () => {
        setLoading(true);
        try {
            const data = await getPostalCodes();
            setPostalCodes(data);
        } catch {
            setError('Error loading postal codes');
        } finally {
            setLoading(false);
        }
    };

    const loadCities = async () => {
        try {
            const data = await fetchCities();
            setCities(Array.isArray(data) ? data : []);
        } catch {
            setError('Error loading cities');
        }
    };

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (!form.cityId) {
            setError('City is required');
            return;
        }

        try {
            const payload = {
                code: form.code,
                cityId: Number(form.cityId)
            };

            if (editId) {
                await updatePostalCode(editId, payload);
                setSuccess('Postal code updated');
            } else {
                await createPostalCode(payload);
                setSuccess('Postal code created');
            }

            setForm({ code: '', cityId: '' });
            setEditId(null);
            fetchPostalCodes();

        } catch {
            setError('Error saving postal code');
        }
    };

    const handleEdit = async (id) => {
        try {
            const data = await getPostalCodeById(id);

            setForm({
                code: data.code,
                cityId: data.cityId || ''
            });

            setEditId(id);
        } catch {
            setError('Error loading postal code');
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Delete this postal code?')) return;

        try {
            await deletePostalCode(id);
            setSuccess('Postal code deleted');
            fetchPostalCodes();
        } catch {
            setError('Error deleting postal code');
        }
    };

    return (
        <div className="p-4">
            <h2 className="text-xl font-bold mb-2">Postal Codes</h2>

            <form onSubmit={handleSubmit} className="mb-4 flex gap-2">

                {/* CODE */}
                <input
                    type="text"
                    name="code"
                    placeholder="Postal Code"
                    value={form.code}
                    onChange={handleChange}
                    className="border p-2 rounded"
                    required
                />

                {/* CITY SELECT */}
                <select
                    name="cityId"
                    value={form.cityId}
                    onChange={handleChange}
                    className="border p-2 rounded"
                    required
                >
                    <option value="">Select city</option>
                    {cities.map(c => (
                        <option key={c.id} value={c.id}>
                            {c.name}
                        </option>
                    ))}
                </select>

                <button className="bg-blue-500 text-white px-4 py-2 rounded">
                    {editId ? 'Update' : 'Add'}
                </button>

                {editId && (
                    <button
                        type="button"
                        onClick={() => {
                            setEditId(null);
                            setForm({ code: '', cityId: '' });
                        }}
                        className="ml-2 text-gray-500"
                    >
                        Cancel
                    </button>
                )}
            </form>

            {loading && <div>Loading...</div>}
            {error && <div className="text-red-500">{error}</div>}
            {success && <div className="text-green-600">{success}</div>}

            <table className="min-w-full border">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Code</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {postalCodes.map(item => (
                        <tr key={item.id}>
                            <td>{item.id}</td>
                            <td>{item.code}</td>
                            <td>
                                <button onClick={() => handleEdit(item.id)}>Edit</button>
                                <button onClick={() => handleDelete(item.id)}>Delete</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default PostalCodePage;